import { doRequest } from '@r1-frontend/do-request/index';
import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites/dto/ResponseDto';
import { getTopCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-top-cities';

import { setTopCities } from '~/src/components/CitySelectContainer/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import selectProviderId from '~/src/store/selectors/selectProviderId';

const fetchTopCities = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const providerId = selectProviderId(state);

        const resp = await doRequest.apiContent<ICitySatellite[]>(
            getTopCities(providerId),
        );

        if (resp.isSuccess) {
            dispatch(setTopCities(resp.payload));
        }
    };
};

export default fetchTopCities;
